import { createContext, useContext, useMemo, useState, type ReactNode } from "react";

/**
 * MVP-Tenant-Context: hardcoded "demo" als Default.
 *
 * H7 (Multi-Tenant) ersetzt das durch eine echte Auswahl + Auth-Layer.
 * Bis dahin reicht ein In-Memory-Switch, falls Frank zwischen Test-
 * Tenants wechseln will.
 */

interface TenantState {
  tenantId: string;
  setTenantId: (id: string) => void;
}

const TenantCtx = createContext<TenantState | null>(null);

export function TenantProvider({ children }: { children: ReactNode }) {
  const [tenantId, setTenantId] = useState("demo");
  const value = useMemo(() => ({ tenantId, setTenantId }), [tenantId]);
  return <TenantCtx.Provider value={value}>{children}</TenantCtx.Provider>;
}

export function useTenant(): TenantState {
  const ctx = useContext(TenantCtx);
  if (!ctx) throw new Error("useTenant must be used within TenantProvider");
  return ctx;
}
